module.exports = __webpack_public_path__ + "static/media/logo.e7f6823a.png";